import { ALL_MARKETS, ALL_WAVES } from 'src/types/constants';

export function setHighlights(state, value) {
  state.settings.highlights = value;
}

export function setUser(state, value: User) {
  if (value.markets) {
    if (!value.markets.length) {
      value.markets = ALL_MARKETS;
    } else {
      if (value.markets.includes(10)) value.markets.push(11, 12, 13, 14);
      if (value.markets.includes(44)) value.markets.push(1, 2, 3, 4);
    }
  }
  if (value.years) {
    if (!value.years.length) value.years = ALL_WAVES;
  }
  state.user = value;
}

export function setSettings(state, settings) {
  Object.assign(state.settings, settings);
}

export function addInsights(state, payload) {
  state.origin_insights = payload.origin;
  state.archetypes_insights = payload.archetypes;
}
